export default {
    title: '数据集目录',
    subtitle: 'Dataset Catalog',
    backTitle: '天地一体频谱认知智能实验室公开频谱数据集',
    connect: '联系我们',
    TAddress: '地址',
    address: '南京市江宁区将军大道29号 南京航空航天大学（将军路校区）',
    TEMail: '邮箱',
    queryPlaceholder: '请输入数据集名称',
    SpectrumDataset: '频谱数据集',
    ChannelDataset: '信道数据集',
    SignalDataset: '信号数据集',
    dashboard:{
        datalistCnt: '数据集',
        visitorCnt: '访问量',
        downloadCnt: '下载量',
    },
    table: {
        columns: {
            id: '序号',
            name: '数据集',
            creator: '上传人',
            remark: '简介',
            tags: '标签',
            size: '数据大小',
            createdTime: '上传时间',
            downloadCnt: '下载次数',
            action: '操作',
            detailBtn: '详情'
        }
    },
    remark:{
        title: '数据集描述'
    }
}
